// Copyright (c) 2023 Proto Labs, Inc. All Rights Reserved.

import { createStore } from 'vuex';
import info, {State as InfoState} from './info';
import geolocation, {State as GeoState} from './geolocation';
import user, { State as UserState } from './user';

export interface IState {
    user: UserState;
    info: InfoState;
    geolocation: GeoState;
}

export const Store = createStore<IState>({
    modules: {
        user,
        info,
        geolocation,
    },
});

export default Store;
